"use client";
import { useState } from "react";
import { CGSummary } from "./CGSummary";
import { CGForm } from "./CGForm";

import s from "./ConclusionGenerator.module.scss";
import cn from "classnames";
import st from "@/styles/modules/typography.module.scss";

export type SummaryDataType = {
  originalLength?: string;
  summaryLength?: string;
  summaryRatio?: string;
  textSummarize?: string;
};

export const ConclusionGenerator = () => {
  const [isSummary, setIsSummary] = useState(false);
  const [text, setText] = useState("");
  const [summaryData, setSummaryData] = useState<SummaryDataType>();

  const formProps = {
    setText,
    setSummaryData,
    setIsSummary,
  };

  const summaryProps = {
    summaryData,
    text,
    setIsSummary,
  };

  return (
    <div className={cn(st.card, s.tool)}>
      {isSummary ? <CGSummary {...summaryProps} /> : <CGForm {...formProps} />}
    </div>
  );
};
